import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carDrivyOpen"
const CarDrivyOpenIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.7388951,12.0226457 C16.8236909,12.0077617 16.910939,12 17,12 C17.8284271,12 18.5,12.6715729 18.5,13.5 C18.5,14.3284271 17.8284271,15 17,15 L16.9948356,14.9999913 C17,15.3498948 17,15.6859089 17,16 L17,20.9970707 C17,21.5509732 16.5566468,22 15.9906311,22 L14.0093689,22 C13.4519098,22 13,21.5621186 13,20.9970707 L13,20 L6,20 L6,20.9970707 C6,21.5509732 5.55664682,22 4.9906311,22 L3.0093689,22 C2.45190985,22 2,21.5621186 2,20.9970707 L2,16.0029293 L2.00000413,16 C2,15.6859089 2,15.3498948 2.00516435,14.9999913 L2,15 C1.17157288,15 0.5,14.3284271 0.5,13.5 C0.5,12.6715729 1.17157288,12 2,12 C2.08906099,12 2.17630912,12.0077617 2.26110486,12.0226457 C2.67444646,9.87798998 3.74212774,8 6.5,8 L12.5,8 C15.2578723,8 16.3255535,9.87798998 16.7388951,12.0226457 L16.7388951,12.0226457 Z M14.9055401,13.3066755 C14.6608385,10.9276319 14.0167969,10 12.5,10 L6.5,10 C4.98320306,10 4.33916152,10.9276319 4.09445989,13.3066755 C4.07039073,13.5406812 4.05215122,13.7640485 4.0384449,14 L14.9615551,14 C14.9478488,13.7640485 14.9296093,13.5406812 14.9055401,13.3066755 Z M5,18.25 C5.69035594,18.25 6.25,17.6903559 6.25,17 C6.25,16.3096441 5.69035594,15.75 5,15.75 C4.30964406,15.75 3.75,16.3096441 3.75,17 C3.75,17.6903559 4.30964406,18.25 5,18.25 Z M14,18.25 C14.6903559,18.25 15.25,17.6903559 15.25,17 C15.25,16.3096441 14.6903559,15.75 14,15.75 C13.3096441,15.75 12.75,16.3096441 12.75,17 C12.75,17.6903559 13.3096441,18.25 14,18.25 Z M19.3743411,8.10373883 C19.6030616,8.60643693 19.3809589,9.19936886 18.8782608,9.42808936 C18.3755627,9.65680985 17.7826308,9.43470712 17.5539103,8.93200902 C16.7480863,7.16091213 14.9798777,6 13,6 C12.4477153,6 12,5.55228475 12,5 C12,4.44771525 12.4477153,4 13,4 C15.7710874,4 18.2467173,5.62536746 19.3743411,8.10373883 Z M23.016475,6.44763318 C23.2452639,6.95030017 23.0232418,7.54326229 22.5205748,7.77205114 C22.0179078,8.00083999 21.4249456,7.77881789 21.1961568,7.27615089 C19.7455967,4.08915698 16.5630953,2 13,2 C12.4477153,2 12,1.55228475 12,1 C12,0.44771525 12.4477153,0 13,0 C17.3542072,0 21.2440599,2.55349866 23.016475,6.44763318 Z" />
    </svg>
  )
}
export default CarDrivyOpenIcon
